import axios from 'axios';
import { AppTrackLocation } from '../models/AppTrackLocation';

const API_URL = process.env.REACT_APP_SERVER_URL + "/app/track/locations";

const authHeader = () => ({
    Authorization: `Bearer ${localStorage.getItem('gpcwstoken_kw')}`,
});

export const AppTrackLocationService = {
    getTrackLocationsPaginated: async (
        page: number,
        limit: number,
        search?: string,
        warehouseId?: string | number
    ): Promise<{ locations: AppTrackLocation[]; total: number }> => {
        const params: Record<string, any> = { page, limit };
        if (search) params.search = search;
        if (warehouseId !== undefined && warehouseId !== null && warehouseId !== '') params.warehouseId = warehouseId;
        const response = await axios.get(`${API_URL}/getLocationsPaginated`, { params, headers: authHeader() });
        return response.data;
    },
    getAllTrackLocations: async (): Promise<AppTrackLocation[]> => {
        const response = await axios.get(`${API_URL}/getAllLocations`, { headers: authHeader() });
        return response.data;
    },

    getTrackLocationById: async (id: number): Promise<AppTrackLocation> => {
        const response = await axios.get(`${API_URL}/getLocationById/${id}`, { headers: authHeader() });
        return response.data;
    },

    createTrackLocation: async (trackLocation: Omit<AppTrackLocation, 'id' | 'created_time' | 'updated_time'>) => {
        const response = await axios.post(`${API_URL}/add`, trackLocation, { headers: authHeader() });
        return response.data;
    },

    updateTrackLocation: async (id: number, trackLocation: Omit<AppTrackLocation, 'id' | 'created_time' | 'updated_time'>) => {
        const response = await axios.put(`${API_URL}/update/${id}`, trackLocation, { headers: authHeader() });
        return response.data;
    },

    deleteTrackLocation: async (id: number): Promise<void> => {
        await axios.delete(`${API_URL}/delete/${id}`, { headers: authHeader() });
    }
};
